import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const CookiePolicyScriptFeature: React.FC<Content.CookiePolicyScript> = ({ content }) => {
	const { script } = content?.properties ?? {};
	const [scriptSrc, setScriptSrc] = useState<string>(null);
	const router = useRouter();
	const langSimple = router.locale?.split('-')?.[0].toUpperCase();
	useEffect(() => {
		setScriptSrc(script);
	}, [script]);
	return <script id="CookiePolicy" src={scriptSrc} data-culture={langSimple} async />;
};
